export default "__VITE_PUBLIC_ASSET__bfc573f1__"